import enums from "../utilities/enums"
import { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal, Table, Dropdown } from "react-bootstrap";
import useApi from "../utilities/useApi";
import { useNavigate } from "react-router-dom";
import Loading from "./common/loading";
import arrayUtilities from "../utilities/arrayUtilities";
export default function Skus({ organisationId }) {
    const { api } = useApi();
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState(null)
    const [modalSku, setModalSku] = useState(null)
    const [errorModal, setErrorModal] = useState(null)

    const getSkus = () => {
        setIsLoading(true)
        api.fetchAllSkus(
            data => {
                setData(data)
                setIsLoading(false)
            },
            error => console.log(error)
        )
    }

    useEffect(() => getSkus(), [])

    const deleteSku = (id) => {
        api.deleteSku(
            id,
            () => {
                getSkus()
                setModalSku(null)
            },
            error => {
                setModalSku(null)
                setErrorModal(error.errorMessage)
            }
        )
    }

    return <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2'>
        <Row>
            <Col className='mb-5'>
                <div className='d-flex justify-content-between my-5 w-100'>
                    <h1 className="h2 m-0">SKUs</h1>
                    <div className='d-flex align-items-center gap-2'>
                        <Button size='sm' onClick={ () => navigate(`/${ organisationId }/admin-tools/skus/add`) }>
                            <i className='fi-plus me-2'></i>
                            Add SKU
                        </Button>
                    </div>
                </div>
                {
                    isLoading
                        ? <Loading />
                        : <Table hover>
                            <thead>
                                <tr>
                                    <th>SKU</th>
                                    <th>Product</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    !arrayUtilities.isNullOrEmpty(data) &&
                                    data.map(
                                        item => <tr key={ item.id }>
                                            <td>{ item.id }</td>
                                            <td>{ enums.ProductType[item.product] }</td>
                                            <td className="text-end">
                                                <Dropdown>
                                                    <Dropdown.Toggle className='bg-none btn-secondary organisation-options-dropdown-toggle'><i className='fi-dots-vertical'></i></Dropdown.Toggle>
                                                    <Dropdown.Menu align='end' className='my-1'>
                                                        <Dropdown.Item onClick={ () => navigate(`/${ organisationId }/admin-tools/skus/${item.id}`) }>
                                                            Edit
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={ () => setModalSku(item) }>
                                                            Delete
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                }
            </Col>
        </Row>
        {
            modalSku &&
            <Modal show onHide={ () => setModalSku(null) } centered>
                <Modal.Header>
                    <Modal.Title>Delete SKU</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the SKU {modalSku.id}?
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='secondary' onClick={ () => setModalSku(null) }>Cancel</Button>
                    <Button size="sm" variant="primary" onClick={ () => deleteSku(modalSku.id) }>Confirm</Button>
                </Modal.Footer>
            </Modal>
        }

        {
            errorModal &&
            <Modal show onHide={ () => setErrorModal(null) } centered>
                <Modal.Header>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    { errorModal.errorMessage }
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant='secondary' onClick={ () => setErrorModal(null) }>Close</Button>
                </Modal.Footer>
            </Modal>
        }
    </Container>
}